import React, { Component } from 'react';
import Modal from '../components/Modal.js';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import helpers from '../util/helpers';

import "../css/OverallStudyResults.css";

class MoreModal extends Component {
  render() {
    return (
      <Modal onClose={this.props.onClose} className='left-align' fullScreen={true}>
        {this.props.children}
      </Modal>
    );
  }
}

class OverallStudyResultsPage extends Component {
  constructor(props) {
    super(props);
    let numHeadlines = props.intl.messages[`page.overallstudyresults.number_headlines`];
    let arrayOfFalse = new Array(numHeadlines).fill(false);
    this.state = {
      modals: arrayOfFalse,
      numHeadlines: numHeadlines,
    };
  }

  onClick(index) {
    helpers.eventLog("modal - OverallStudyResults - "+index);
    let arrayOfFalse = new Array(this.state.numHeadlines).fill(false);
    arrayOfFalse[index] = true;
    this.setState({ modals: arrayOfFalse });
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  onClose() {
    let arrayOfFalse = new Array(this.state.numHeadlines).fill(false);
    this.setState({ modals: arrayOfFalse });
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }

  render() {
    const that = this

    let countUpArray = [];
    for (let i = 0; i < this.state.numHeadlines; i++) {
      countUpArray.push(i);
    }

    const modals = countUpArray.map((index) =>
      this.state.modals[index] ?
        (<MoreModal onClose={that.onClose.bind(that)}>
          <h4><FormattedMessage id={`page.overallstudyresults.item${index + 1}.title`}  /></h4>

          <FormattedHTMLMessage id={`page.overallstudyresults.item${index + 1}.content`}  />
        </MoreModal>) : null
    );

    let items = countUpArray.map((index) =>
      (<div key={index}>
        <div className='item'>
          <div className='image'>
            <img src={`${process.env.PUBLIC_URL}${this.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.image']}`} alt='' />
          </div>

          <div className='content'>
            <p><FormattedMessage id={`page.overallstudyresults.item${index + 1}.title`} /></p>

            <a className='button right secondary' onClick={() => this.onClick.bind(this)(index)}>
              <FormattedMessage id='learn_more' />
            </a>
          </div>
        </div>
        {modals[index]}
      </div>)
    );

    const displaynone = {display:'none'}

    const items_print = countUpArray.map((index) =>
    {

      let thecontent = this.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.content'];
      // <p><FormattedHTMLMessage id={`page.overallstudyresults.item${index + 1}.content`} /></p>

      // special re-formatting of the yaml content for print
      thecontent = thecontent.replace(/[\r\n\t ]+/g, ' '); //remove line breaks/whitespace to make matching easier in next line
      thecontent = thecontent.replace(/><\/p> <p>/g, ' > <!-- remove extra p after image -->');
      thecontent = thecontent.replace(/<img/g , '<img style="margin-left:20px;margin-bottom:15px;width:200px;" align="right"'); // small and right-aligned
      thecontent = thecontent.replace(/<p>(.*)(<img.*?>)(.*)/ , '<p>$2$1$3'); // force 1 image to the top!

      thecontent = <div dangerouslySetInnerHTML={{__html: thecontent}} />;


      return (<div key={index}>
          <div className='item'>

            <div className='image' style={displaynone}>
              <img src={`${process.env.PUBLIC_URL}${this.props.intl.messages['page.overallstudyresults.item' + (index + 1) + '.image']}`} alt='' />
            </div>


            <div className='content'>
              <h3><FormattedMessage id={`page.overallstudyresults.item${index + 1}.title`} /></h3>

              {thecontent}

            </div>
          </div>
        </div>)
      }
    );

    if (helpers.findGetParameter('print')) {
      // inline for print #5 -- overall study results -- show the full MORE INFO content and small images
      items = items_print;
    }

    return (
      <div style={{maxWidth: '850px'}} className="page overallstudyresults">
        <h1>
          <FormattedMessage id='page.overallstudyresults.title' defaultMessage='Overall Study Results' />
        </h1>

        {items}
      </div>
    );
  }
}

export default injectIntl(OverallStudyResultsPage);



// WEBPACK FOOTER //
// ./src/pages/OverallStudyResultsPage.js